import React from 'react';
import { IonModal, IonButton, IonIcon } from '@ionic/react';
import backArrow from '../../assets/images/back-arrow.svg'
import './index.css';
import { isNativeIos } from '../../lib/utils';
import { Subtitle, Title } from '../common';
import { arrowBack, closeOutline } from 'ionicons/icons';

export default class Modal extends React.Component {
	render() {
		const { children, title, action, actionLabel, className, scrollable, showCancelButton, cancelButtonLabel, showBackArrow,alertType, ...rest } = this.props;
		const { onDidDismiss } = rest;

		return (
			<IonModal className={`modal-classic modal-wrapper ${className ? className : ''} ${alertType? 'modal-type-alert':''}`} {...rest}>
				<div className={'modal-classic-wrapper' + (scrollable ? ' scrollable-y' : '')}>
					{onDidDismiss && !showCancelButton ? (
						<>
							{showBackArrow ? (
								<div className={`modal-back-arrow-closer ${isNativeIos() ? 'ios-modal-back-arrow-close' : ''}`} onClick={onDidDismiss}>
									<IonIcon  icon={arrowBack} />
								</div>

							) : (
								<div className={`modal-classic-closer ${isNativeIos() ? 'ios-modal-classic-closer' : ''}`} onClick={onDidDismiss}>
									<IonIcon  icon={closeOutline}/>
								</div>
							)}
						</>
					) : null}
					{title ? (
						<div className="modal-classic-header">
							<Subtitle>{title}</Subtitle>
						</div>
					) : null}
					<div className={`modal-classic-content ${isNativeIos() ? 'ios-modal-classic-content' : ''}`}>{children}</div>
					{action ? (
						<div className="modal-classic-action">
							<IonButton expand="block" color="primary" onClick={action}>
								{actionLabel || '--'}
							</IonButton>
						</div>
					) : null}
					{showCancelButton && (
						<div className="modal-classic-action">
							<IonButton expand="block" color="primary"  className="link underlined" onClick={action}>
								{cancelButtonLabel || 'cancel'}
							</IonButton>
						</div>
					)}
				</div>
			</IonModal>
		);
	}
}
